export default __webpack_public_path__ + "static/media/fniris1.993b9dcd.png";